import React, { useState } from 'react';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { Link, useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import SkinconcernForm from '../../components/skinconcerns/SkinconcernForm';
import { convertToFormData } from '../../shared/upload';
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/skinconcerns_enum';
import {
  useUpdateSkinconcern,
  useSingleSkinconcern,
  useGetDropdownOptions,
} from '../../shared/hooks/UseSkinconcern';
import { useDispatch } from 'react-redux';
import api from '../../domain/api';

const EditSkinconcern = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSingleSkinconcern(match.params.id);
  const [updateData] = useUpdateSkinconcern();
  const {
    skinconcern_loading,
    skinconcern,
    edit_skinconcern_loading,
  } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);
  const dispatch = useDispatch();
  const [dropdownOptions, loadOptions] = useGetDropdownOptions();
  const submitFormClicked = async (values) => {
    await api.put(`/skinconcerns/${skinconcern._id}`, values);
    history.push(`/${LINK_URL}/${skinconcern._id}/view`);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='Edit'
        />
      </div>
      <div className='container-fluid'>
        <div className='col-lg-12'>
          <div className='card'>
            {!skinconcern_loading ? (
              skinconcern && (
                <div>
                  <div className='card-header'>
                    <div>
                      <h4 className='card-title'>
                        {skinconcern[Object.keys(inputFields)[0]]} -{' '}
                        <span>Edit</span>{' '}
                      </h4>
                      <p className='card-title-desc'>
                        <Link
                          to={`/${LINK_URL}`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-angle-left'></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${skinconcern._id}/view`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-eye'></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <SkinconcernForm
                    data={skinconcern}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_skinconcern_loading}
                    loadOptions={loadOptions}
                  />
                </div>
              )
            ) : (
              <div className='text-center'>
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSkinconcern;
